import { createSlice } from "@reduxjs/toolkit";
import {
  ChildRegistrationDetailsQRCodeDetails,
  ChildRegistrationFullDetails,
} from "pages/offlineContestManagement/models";

interface OfflineContestManagementState {
  childRegistrationData: ChildRegistrationFullDetails | null;
  childRegistrationDataQRCode: ChildRegistrationDetailsQRCodeDetails | null;
  isAttendanceMarked: boolean;
  isAttendanceMarkedLoading: boolean;
}

const offlineContestManagementInitialState = {
  childRegistrationData: null,
  childRegistrationDataQRCode: null,
  isAttendanceMarked: false,
  isAttendanceMarkedLoading: false,
};

export const offlineContestManagementSlice = createSlice({
  name: "offlineContestManagement",
  initialState: offlineContestManagementInitialState,
  reducers: {
    setChildRegistrationData: (state, action) => {
      state.childRegistrationData = action.payload;
      state.isAttendanceMarked = action.payload?.isAttendanceMarked || false;
    },
    setChildRegistrationDataQRCode: (state, action) => {
      state.childRegistrationDataQRCode = action.payload;
    },
    setIsAttendanceMarked: (state, action) => {
      state.isAttendanceMarked = action.payload;
    },
    setIsAttendanceMarkedLoading: (state, action) => {
      state.isAttendanceMarkedLoading = action.payload;
    },
  },
});

export const selectOfflineContestManagement = (state: any) =>
  state.offlineContestManagement;

export const selectChildRegistrationData = (state: any) =>
  state.offlineContestManagement.childRegistrationData;

export const selectChildRegistrationDataQRCode = (state: any) =>
  state.offlineContestManagement.childRegistrationDataQRCode;

export const selectIsAttendanceMarked = (state: any) =>
  state.offlineContestManagement.isAttendanceMarked;

export const selectIsAttendanceMarkedLoading = (state: any) =>
  state.offlineContestManagement.isAttendanceMarkedLoading;

export const {
  setChildRegistrationData,
  setChildRegistrationDataQRCode,
  setIsAttendanceMarked,
  setIsAttendanceMarkedLoading,
} = offlineContestManagementSlice.actions;

export default offlineContestManagementSlice.reducer;